<div class="primary_points">
    <div class="primary_box">
        <mat-card class="__inner">
            <mat-card-content>
                Create Company
                45 Total Active Compaines
            </mat-card-content>
        </mat-card>
    </div>
    <div class="primary_box">
        <mat-card class="__inner">
            <mat-card-content>
                Create Role
                45 Total Active Roles
            </mat-card-content>
        </mat-card>
    </div>
    <div class="primary_box">
        <mat-card class="__inner">
            <mat-card-content>
                Company Wise Profilt & loss report
                45 Total Active Roles
            </mat-card-content>
        </mat-card>
    </div>
    <div class="primary_box">
        <mat-card class="__inner">
            <mat-card-content>
                Create Role
                45 Total Active Roles
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div class="secondary_points">
    <div class="secondary_box">
        <div class="__inner">
            <div class="chart-wrapper">
                <canvas baseChart [data]="pieChartData" [type]="pieChartType"
                    [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend">
                </canvas>
            </div>
        </div>
    </div>
    <div class="secondary_box">
        <div class="__inner">
            <div class="chart-wrapper">
                <canvas baseChart [data]="doughnutChartData" [type]="doughnutChartType">
                </canvas>
            </div>
        </div>
    </div>
</div>




<div class="chart-wrapper">
    <canvas baseChart [data]="lineChartData" [options]="lineChartOptions"
        [legend]="lineChartLegend" [type]="lineChartType" [plugins]="lineChartPlugins">
    </canvas>
</div>
<div class="chart-wrapper">
    <canvas baseChart [data]="barChartData" [options]="barChartOptions"
        [plugins]="barChartPlugins" [legend]="barChartLegend" [type]="barChartType">
    </canvas>
</div>
<div class="secondary_points _40_60">
    <div class="secondary_box">
        <div class="__inner">
        </div>
    </div>
    <div class="secondary_box _pintress">
        <div class="small_box">
            <div class="__inner">
            </div>
        </div>
        <div class="small_box">
            <div class="__inner">
            </div>
        </div>
        <div class="small_box _full_width">
            <div class="__inner">
            </div>
        </div>
    </div>
</div>